export class OperationalParametric {

  static path = '/parametricas/';
  id: number;
  description: string;

  constructor () {

  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/operationalParametric.model.ts